import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { StyledTabs, StyledTab } from './styles';

const Tabs = () => {
  const location = useLocation();
  const { pathname } = location;
  const [selectedTab] = useState(pathname?.includes('my-tasks') ? 0 : null);

  return (
    <StyledTabs
      value={selectedTab}>
      <StyledTab
        label='My tasks'
      />
    </StyledTabs>
  );
};

export default Tabs;
